module.exports = __webpack_public_path__ + "img/transport.38d1f866.svg";